"use client"

import { useEffect, useState } from "react"
import {
  Alert,
  Autocomplete,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material"
import { RRHH_ESTADOS_ASISTENCIA } from "./rrhhUi.js"

const buildInitialForm = (asistencia = null) => ({
  estadoAsistencia: asistencia?.estadoAsistencia || "PRESENTE",
  cerrado: asistencia?.cerrado === true,
  requiereRevision: asistencia?.requiereRevision === true,
  observaciones: asistencia?.observaciones || "",
})

const ModalRrhhAsistencia = ({
  open,
  onClose,
  onSubmit,
  asistencia = null,
  submitting = false,
}) => {
  const [form, setForm] = useState(buildInitialForm(asistencia))
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!open) return
    setForm(buildInitialForm(asistencia))
    setError(null)
  }, [open, asistencia])

  const handleSubmit = async () => {
    if (!form.estadoAsistencia) {
      setError("El estado de asistencia es requerido.")
      return
    }

    setError(null)
    await onSubmit({
      estadoAsistencia: form.estadoAsistencia,
      cerrado: form.cerrado,
      requiereRevision: form.requiereRevision,
      observaciones: form.observaciones,
    })
  }

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Ajustar asistencia</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2.5} sx={{ pt: 0.5 }}>
          {error && <Alert severity="error">{error}</Alert>}

          <Autocomplete
            options={RRHH_ESTADOS_ASISTENCIA}
            value={RRHH_ESTADOS_ASISTENCIA.find((option) => option.value === form.estadoAsistencia) || null}
            onChange={(_, value) =>
              setForm((prev) => ({
                ...prev,
                estadoAsistencia: value?.value || "",
              }))
            }
            renderInput={(params) => <TextField {...params} label="Estado de asistencia" required />}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={form.cerrado}
                onChange={(event) =>
                  setForm((prev) => ({
                    ...prev,
                    cerrado: event.target.checked,
                  }))
                }
              />
            }
            label="Marcar asistencia como cerrada"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={form.requiereRevision}
                onChange={(event) =>
                  setForm((prev) => ({
                    ...prev,
                    requiereRevision: event.target.checked,
                  }))
                }
              />
            }
            label="Requiere revisión"
          />

          <TextField
            label="Observaciones"
            value={form.observaciones}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                observaciones: event.target.value,
              }))
            }
            multiline
            minRows={4}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancelar</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={submitting}>
          {submitting ? "Guardando..." : "Guardar cambios"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalRrhhAsistencia
